(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["heritage-bullion-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  const controllers = new WeakMap();
  const initialize = (scope) => {
    scope.querySelectorAll('.ht-header').forEach((root) => {
      if (controllers.has(root)) return;
      const controller = new AbortController();
      controllers.set(root, controller);
      const options = { signal: controller.signal };
      const openButton = root.querySelector('[data-ht-menu-open]');
      const setMenu = (open) => {
        root.classList.toggle('is-menu-open', open);
        openButton?.setAttribute('aria-expanded', String(open));
        document.documentElement.style.overflow = open ? 'hidden' : '';
      };
      openButton?.addEventListener('click', () => setMenu(true), options);
      root.querySelectorAll('[data-ht-menu-close]').forEach(button => button.addEventListener('click', () => setMenu(false), options));
      document.addEventListener('keydown', event => { if (event.key === 'Escape' && root.classList.contains('is-menu-open')) setMenu(false); }, options);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.ht-header').forEach(root => {
      controllers.get(root)?.abort();
      controllers.delete(root);
      if (root.classList.contains('is-menu-open')) document.documentElement.style.overflow = '';
    });
  });
})();

if (!customElements.get('ht-sticky-header')) {
  customElements.define('ht-sticky-header', class extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('.ht-sticky-header__bar');
      if (!this.bar) return;
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      this.media = matchMedia(this.dataset.breakpoint === 'mobile' ? '(max-width:1023px)' : '(min-width:1024px)');
      const options = { signal: this.controller.signal };
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      };
      window.addEventListener('scroll', this.schedule, { ...options, passive: true });
      window.addEventListener('resize', this.schedule, options);
      this.media.addEventListener('change', this.schedule, options);
      this.measure = () => {
        const height = this.bar.getBoundingClientRect().height;
        if (height !== this.height) {
          this.height = height;
          this.style.setProperty('--ht-sticky-height', height + 'px');
        }
        this.schedule();
      };
      this.observer = new ResizeObserver(this.measure);
      this.observer.observe(this.bar);
      this.measure();
      this.update();
    }
    update() {
      const matches = this.media.matches;
      const active = this.dataset.enabled === 'true' && matches && this.getBoundingClientRect().top <= 0;
      if (active !== this.active) {
        this.active = active;
        this.classList.toggle('is-sticky', active);
      }
      if (matches) {
        const height = active ? this.height + 'px' : '0px';
        if (document.documentElement.style.getPropertyValue('--ht-sticky-header-height') !== height) {
          document.documentElement.style.setProperty('--ht-sticky-header-height', height);
        }
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      if (this.media?.matches) document.documentElement.style.removeProperty('--ht-sticky-header-height');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ht-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__htFooterHeadingAlignment) return;
    window.__htFooterHeadingAlignment = true;
    const tablet = window.matchMedia('(min-width: 768px) and (max-width: 1100px)');
    const columnsByElement = new Map();
    let frame = null;
    const headingTextRect = (heading) => {
      const range = document.createRange();
      range.selectNodeContents(heading);
      return range.getBoundingClientRect();
    };
    const updateFooterHeadings = () => {
      frame = null;
      const active = [];
      columnsByElement.forEach((nodes, columns) => {
        if (!columns.isConnected) {
          observer?.unobserve(columns);
          columnsByElement.delete(columns);
          return;
        }
        if (nodes.customer.style.transform) nodes.customer.style.transform = '';
        if (tablet.matches) active.push(nodes);
      });
      const positions = active.map(({ companyHeading, customer, customerHeading, policyHeading }) => {
        const companyRect = headingTextRect(companyHeading);
        const customerRect = headingTextRect(customerHeading);
        const policyRect = headingTextRect(policyHeading);
        const leftGap = customerRect.left - companyRect.right;
        const rightGap = policyRect.left - customerRect.right;
        return { customer, shift: (rightGap - leftGap) / 2 };
      });
      positions.forEach(({ customer, shift }) => {
        customer.style.transform = `translateX(${shift}px)`;
      });
    };
    const scheduleUpdate = () => {
      if (frame === null) frame = requestAnimationFrame(updateFooterHeadings);
    };
    const observer = window.ResizeObserver ? new ResizeObserver(scheduleUpdate) : null;
    const initialize = () => {
      document.querySelectorAll('.hf-columns').forEach((columns) => {
        if (columnsByElement.has(columns)) return;
        const companyHeading = columns.querySelector('.hf-company h3');
        const customer = columns.querySelector('.hf-customer');
        const customerHeading = columns.querySelector('.hf-customer h3');
        const policyHeading = columns.querySelector('.hf-policy h3');
        if (!companyHeading || !customer || !customerHeading || !policyHeading) return;
        columnsByElement.set(columns, { companyHeading, customer, customerHeading, policyHeading });
        observer?.observe(columns);
      });
      scheduleUpdate();
    };
    initialize();
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    document.addEventListener('shopify:section:load', initialize);
    document.addEventListener('shopify:section:unload', scheduleUpdate);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleUpdate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ht-original-banner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ht-banner-grid')) {
  customElements.define('ht-banner-grid', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('.ht-banner-grid__track');
      this.slides = [...this.querySelectorAll('.ht-banner-grid__item')];
      this.dots = [...this.querySelectorAll('.ht-banner-grid__dot')];
      this.media = matchMedia('(max-width:767px)');
      this.dots.forEach((dot,index) => dot.addEventListener('click', () => this.goTo(index), options));
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (!this.media.matches || event.target !== this.track) return;
        const step = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
        if (!step) return;
        event.preventDefault();
        this.goTo(Math.max(0, Math.min(this.slides.length - 1, (this.current || 0) + step)));
      }, options);
      this.media.addEventListener('change', () => {
        this.track.scrollLeft = 0;
        this.update();
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0 && this.media.matches) this.goTo(index);
      }, options);
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.track);
      this.update();
    }
    goTo(index) {
      const target = this.slides[index];
      if (!target || !this.media.matches) return;
      const distance = target.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
      this.track.scrollBy({left:distance,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
    }
    update() {
      const left = this.track.getBoundingClientRect().left;
      let closest = Infinity;
      this.slides.forEach((slide,index) => {
        const distance = Math.abs(slide.getBoundingClientRect().left - left);
        if (distance < closest) { closest = distance; this.current = index; }
      });
      this.dots.forEach((dot,index) => dot.setAttribute('aria-current', String(index === this.current)));
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rv-product-details-unified"]) return;
  try {
    
(() => {
  const initialized = new WeakSet();
  const initialize = (scope) => {
    scope.querySelectorAll('[data-rvp-details]').forEach((root) => {
      if (initialized.has(root)) return;
      initialized.add(root);
  const tabs = root.querySelectorAll('[data-rvp-unified-tab]');
  const panels = root.querySelectorAll('[data-rvp-unified-panel]');
  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const key = tab.dataset.rvpUnifiedTab;
      tabs.forEach((item) => {
        const active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        item.tabIndex = active ? 0 : -1;
      });
      panels.forEach((panel) => {
        const active = panel.dataset.rvpUnifiedPanel === key;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    });
  });
  tabs.forEach((tab, index) => {
    tab.addEventListener('keydown', (event) => {
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = tabs.length - 1;
      else return;
      event.preventDefault();
      tabs[next].click();
      tabs[next].focus();
    });
  });

    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rv-product-main"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialized = new WeakSet();
  const initialize = (scope) => {
    scope.querySelectorAll('[data-rvp-section]').forEach((root) => {
      if (initialized.has(root)) return;
      initialized.add(root);
  const mainImage = root.querySelector('.rvp__main-img');
  const mediaButtons = root.querySelectorAll('[data-rvp-media]');
  mediaButtons.forEach((button) => {
    button.addEventListener('click', () => {
      if (mainImage) {
        mainImage.src = button.dataset.src;
        mainImage.alt = button.dataset.alt || root.querySelector('.rvp__title').textContent;
      }
      mediaButtons.forEach((item) => item.classList.remove('is-active'));
      root.querySelectorAll(`[data-rvp-media][data-src="${CSS.escape(button.dataset.src)}"]`).forEach((item) => item.classList.add('is-active'));
    });
  });
  const qty = root.querySelector('input[name="quantity"]');
  root.querySelector('[data-rvp-minus]')?.addEventListener('click', () => { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
  root.querySelector('[data-rvp-plus]')?.addEventListener('click', () => { qty.value = (parseInt(qty.value, 10) || 1) + 1; });

  const variantSelect = root.querySelector('[data-rvp-variant]');
  const variantId = root.querySelector('[data-rvp-variant-id]');
  const price = root.querySelector('[data-rvp-price]');
  const compare = root.querySelector('[data-rvp-compare]');
  const save = root.querySelector('[data-rvp-save]');
  const stock = root.querySelector('[data-rvp-stock]');
  const atc = root.querySelector('[data-rvp-atc]');
  const stickyPrice = root.querySelector('[data-rvp-sticky-price]');
  const stickyCompare = root.querySelector('[data-rvp-sticky-compare]');
  const stickyAtc = root.querySelector('[data-rvp-sticky-atc]');
  variantSelect?.addEventListener('change', () => {
    const opt = variantSelect.options[variantSelect.selectedIndex];
    const available = opt.dataset.available === 'true';
    variantId.value = opt.value;
    price.textContent = opt.dataset.price || '';
    stickyPrice.textContent = opt.dataset.price || '';
    if (opt.dataset.compare) {
      compare.textContent = opt.dataset.compare; compare.classList.remove('is-hidden');
      stickyCompare.textContent = opt.dataset.compare; stickyCompare.classList.remove('is-hidden');
    } else {
      compare.textContent = ''; compare.classList.add('is-hidden');
      stickyCompare.textContent = ''; stickyCompare.classList.add('is-hidden');
    }
    const pct = parseInt(opt.dataset.save || '0', 10);
    if (pct > 0) { save.textContent = `SAVE ${pct}%`; save.classList.remove('is-hidden'); } else { save.textContent = ''; save.classList.add('is-hidden'); }
    stock.classList.toggle('is-sold', !available);
    stock.innerHTML = `<i></i>${available ? 'In Stock' : 'Sold Out'}`;
    atc.disabled = !available; atc.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
    stickyAtc.disabled = !available; stickyAtc.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
    if (mainImage && opt.dataset.image) mainImage.src = opt.dataset.image;
  });

  const mainMedia = root.querySelector('.rvp__main-media');
  const dots = Array.from(root.querySelectorAll('.rvp__dot[data-rvp-media]'));
  if (!mainMedia || dots.length < 2) return;

  let startX = 0;
  let startY = 0;
  let activeIndex = Math.max(0, dots.findIndex((dot) => dot.classList.contains('is-active')));

  const syncIndexFromDots = () => {
    const current = dots.findIndex((dot) => dot.classList.contains('is-active'));
    if (current >= 0) activeIndex = current;
  };

  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => { activeIndex = index; });
  });

  mainMedia.addEventListener('touchstart', (event) => {
    if (!event.touches || event.touches.length !== 1) return;
    const touch = event.touches[0];
    startX = touch.clientX;
    startY = touch.clientY;
    syncIndexFromDots();
  }, { passive: true });

  mainMedia.addEventListener('touchend', (event) => {
    if (!event.changedTouches || !event.changedTouches.length) return;
    const touch = event.changedTouches[0];
    const dx = touch.clientX - startX;
    const dy = touch.clientY - startY;
    const threshold = Math.max(34, mainMedia.clientWidth * 0.08);

    if (Math.abs(dx) < threshold || Math.abs(dx) <= Math.abs(dy) * 1.1) return;

    activeIndex = dx < 0
      ? (activeIndex + 1) % dots.length
      : (activeIndex - 1 + dots.length) % dots.length;

    dots[activeIndex].click();
  }, { passive: true });

    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
